import { render, staticRenderFns } from "./EventShifts.vue?vue&type=template&id=9f718a38&"
import script from "./EventShifts.vue?vue&type=script&lang=js&"
export * from "./EventShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports